import React, { useState } from "react";
import { Modal, Typography, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { getCurrentUser, fetchAuthSession } from "@aws-amplify/auth";
import axios from "axios";
import { ADMIN_GAMES } from "../../../constants/api";
import { R_ACTIVITIES } from "../../../constants/routes";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import ButtonActions from "../../../Components/Buttons/ButtonActions/ButtonActions";

const { Title, Paragraph } = Typography;

const ModalDeleteActivities = ({ open, handleCancel, game }) => {
  const [buttonDisable, setButtonDisable] = useState(false);
  const history = useHistory();

  //Função para deletar o jogo
  const deleteGame = (id) => {
    setButtonDisable(true);
    if (!id) {
      console.log("ID do jogo não fornecido");
      return;
    }

    const url = `${ADMIN_GAMES}/${id}`;
    console.log("URL para DELETE:", url);

    getCurrentUser()
      .then(async (user) => {
        const session = await fetchAuthSession({
          forceRefresh: true,
        });
        const userToken = session.tokens?.idToken?.toString();
        return axios.delete(url, {
          headers: {
            Authorization: userToken,
            "Content-Type": "application/json",
          },
        });
      })
      .then((response) => {
        if (response.status === 200) {
          console.log("status 200");
          handleCancel();
          history.push(R_ACTIVITIES);
          window.location.reload();
        } else {
          console.log(`Erro na exclusão do jogo. Status: ${response.status}`);
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message || error.message || "Erro desconhecido";
        console.log("Erro ao deletar o jogo", errorMessage);
      });
  };

  return (
    <Modal
      width={1000}
      height={407}
      modalRender={(modal) => (
        <div style={{ borderRadius: "14px", overflow: "hidden" }}>{modal}</div>
      )}
      centered
      open={open}
      onCancel={handleCancel}
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <ButtonActions
            variant="outline"
            onClick={handleCancel}
            text="Cancelar"
          />
          <ButtonActions
            variant="danger"
            onClick={() => deleteGame(game.id)}
            disabled={buttonDisable}
            text="Confirmar exclusão"
          />
        </div>
      }
      closeIcon={
        <Button
          shape="circle"
          icon={<CloseOutlined />}
          style={{
            color: "#0D6E7A",
            fontSize: "20px",
            border: "2px solid #0D6E7A",
            background: "transparent",
            borderRadius: "50%",
            padding: "5px",
            boxSizing: "border-box",
            display: "inline-block",
          }}
          onClick={handleCancel}
        />
      }
    >
      <Title
        level={4}
        style={{
          color: "#0D6E7A",
          fontSize: "24px",
          fontWeight: "600",
          margin: "15px 0 30px 20px",
        }}
      >
        Confirmar exclusão
      </Title>
      <Paragraph
        style={{
          color: "#4D4D4D",
          fontSize: "16px",
          fontWeight: "400",
          margin: "15px 0 30px 20px",
        }}
      >
        Deseja excluir a atividade{" "}
        <strong style={{ fontWeight: "700" }}>{game?.name}</strong> ? <br />
        Após a exclusão, ela não poderá ser recuperada.
      </Paragraph>
    </Modal>
  );
};

export default ModalDeleteActivities;
